import { render, staticRenderFns } from "./TurnaroundCard.vue?vue&type=template&id=474b2032"
import script from "./TurnaroundCard.vue?vue&type=script&lang=js"
export * from "./TurnaroundCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports